import { Chain, bsc, bscTestnet, mainnet, polygon, polygonMumbai } from 'wagmi/chains'

import EthereumSvg from '@/assets/imgs/ethereum.svg'
import BscSvg from '@/assets/imgs/bsc.svg'
import PolygonSvg from '@/assets/imgs/polygon.svg'

interface ChainInfo extends Chain {
  shortLabel?: string
  logoSrc: string
  abbreviation?: string
}

export const CHAIN_INFO: Record<number, ChainInfo> = {
  [mainnet.id]: {
    ...mainnet,
    shortLabel: mainnet.name,
    logoSrc: EthereumSvg,
    abbreviation: 'ETH',
  },
  [polygonMumbai.id]: {
    ...polygonMumbai,
    shortLabel: 'Mumbai',
    logoSrc: EthereumSvg,
    abbreviation: 'Mumbai',
  },
  [bsc.id]: {
    ...bsc,
    shortLabel: 'BNB Chain',
    logoSrc: BscSvg,
    abbreviation: 'BSC',
  },
  [bscTestnet.id]: {
    ...bscTestnet,
    shortLabel: 'BNB Testnet',
    logoSrc: BscSvg,
    abbreviation: 'BSC',
  },
  [polygon.id]: {
    ...polygon,
    shortLabel: 'Polygon',
    logoSrc: PolygonSvg,
    abbreviation: 'Polygon',
  },
}

export const ETHEREUM_CHAIN_ID = Number(process.env.NEXT_PUBLIC_ETHEREUM_CHAIN_ID)
export const BSC_CHAIN_ID = Number(process.env.NEXT_PUBLIC_BSC_CHAIN_ID)
export const POLYGON_CHAIN_ID = Number(process.env.NEXT_PUBLIC_POLYGON_CHAIN_ID)

export const SUPPORTED_CHAIN_ID = [ETHEREUM_CHAIN_ID, BSC_CHAIN_ID, POLYGON_CHAIN_ID]
export const SUPPORTED_CHAIN: Record<number, ChainInfo> = {}
SUPPORTED_CHAIN_ID.forEach((chainId) => {
  if (!SUPPORTED_CHAIN[chainId]) {
    SUPPORTED_CHAIN[chainId] = CHAIN_INFO[chainId]
  }
})
// export const SUPPORTED_CHAIN = {
//   [ETHEREUM_CHAIN_ID]: CHAIN_INFO[ETHEREUM_CHAIN_ID],
//   [BSC_CHAIN_ID]: CHAIN_INFO[BSC_CHAIN_ID],
//   [POLYGON_CHAIN_ID]: CHAIN_INFO[POLYGON_CHAIN_ID],
// }
// export const SUPPORTED_CHAIN_ID = Object.keys(SUPPORTED_CHAIN).map((chainId) => Number(chainId))

export const UNISAT_BRC20_URL = 'https://unisat.io/brc20?q='

export const MESSAGE_TIME = Math.round(new Date().getTime() / 1000)
export const MESSAGE_1 = `Multibit User Verify Sign ${MESSAGE_TIME}`
export const MESSAGE_1_BTC_CACHE_KEY = 'BTC message1'
export const MESSAGE_1_EVM_CACHE_KEY = 'EVM message1'

export const MILLISECONDS_IN_A_DAY = 86400000

export const TOKEN_TYPE = {
  [ETHEREUM_CHAIN_ID]: 'ERC 20',
  [POLYGON_CHAIN_ID]: 'ERC 20',
  [BSC_CHAIN_ID]: 'BEP 20',
}

export const HOT_WALLET_ADDRESS = 'bc1p6r6hx759e3ulvggvd9x3df0rqh27jz59nvfjd2fzmh3wqyt6walq82u38z'
export const COLD_WALLET_ADDRESS = 'bc1pyyms2ssr0hagy5j50r5n689e6ye0626v3c98j5fw0jk6tz3vrgts7nt56g'

export const OKLINK_EXPLORAR_URL = 'https://www.oklink.com/btc'
